/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Note } from './note';
import { LoaderStateManager } from '../../manager/loader-state-manager';
import { Observable } from 'rxjs';

export class NoteLoader extends Note {
  public stateManager = new LoaderStateManager();
  public note: Note;

  constructor(
    title: string,
    icon: string,
    message: string,
    observable: Observable<any>,
  ) {
    super(title, icon, message);

    observable.subscribe({
      next: (result) => {
        this.stateManager.success(result);
        setTimeout(() => {
          this.close();
        }, 2000);
      },
      error: (error) => {
        this.stateManager.error(error);
      },
    });
  }
}
